import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-black text-white font-sans" }
const _hoisted_2 = { class: "flex items-center gap-6" }
const _hoisted_3 = { class: "flex items-center gap-6" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center gap-4 bg-white/10 rounded-lg px-4 py-3"
}
const _hoisted_5 = { class: "text-lg flex items-center gap-2" }
const _hoisted_6 = { class: "w-32 h-2 bg-white/20 rounded-full overflow-hidden" }
const _hoisted_7 = { class: "text-sm flex items-center gap-1" }
const _hoisted_8 = {
  key: 0,
  class: "fas fa-clock text-orange-400"
}
const _hoisted_9 = { class: "flex items-center gap-2 bg-white/10 rounded-lg px-4 py-3" }
const _hoisted_10 = { class: "text-lg flex items-center gap-2" }
const _hoisted_11 = { class: "flex gap-2" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_14 = {
  key: 1,
  class: "fas fa-sync-alt"
}
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col items-center justify-center h-96 gap-6"
}
const _hoisted_16 = {
  key: 1,
  class: "mx-8 mt-8 text-center p-8 bg-red-500/20 border border-red-500/30 rounded-xl"
}
const _hoisted_17 = { class: "mb-6 text-red-200 text-lg" }
const _hoisted_18 = {
  key: 2,
  class: "text-center py-20"
}
const _hoisted_19 = {
  key: 3,
  class: "px-8 pb-8",
  style: {"height":"calc(100vh - 200px)"}
}
const _hoisted_20 = { class: "h-full flex flex-col" }
const _hoisted_21 = { class: "mb-8" }
const _hoisted_22 = { class: "bg-white/10 backdrop-blur-sm rounded-xl p-8 shadow-2xl border border-white/20" }
const _hoisted_23 = { class: "flex justify-between items-center" }
const _hoisted_24 = { class: "text-6xl font-light text-green-300 flex items-center gap-4" }
const _hoisted_25 = { class: "flex items-center gap-6 text-5xl" }
const _hoisted_26 = { class: "bg-white/10 rounded-full px-6 py-3 flex items-center gap-3" }
const _hoisted_27 = { class: "bg-blue-500/30 rounded-full px-6 py-3 flex items-center gap-3" }
const _hoisted_28 = { class: "flex-1 overflow-visible relative" }
const _hoisted_29 = {
  class: "absolute inset-0 pointer-events-none",
  style: {"z-index":"50"}
}
const _hoisted_30 = { class: "grid grid-cols-6 gap-8 h-full" }
const _hoisted_31 = {
  key: 0,
  class: "absolute -top-3 -right-3 bg-red-500 text-white text-3xl font-bold px-3 py-2 rounded-full shadow-lg animate-pulse pointer-events-auto"
}
const _hoisted_32 = {
  key: 1,
  class: "absolute -top-2 -left-2 bg-orange-500 text-white text-3xl font-bold px-2 py-1 rounded-full shadow-lg flex items-center gap-1 pointer-events-auto"
}
const _hoisted_33 = { class: "grid grid-cols-6 gap-8 h-full" }
const _hoisted_34 = { class: "flex items-center gap-3" }
const _hoisted_35 = { class: "text-5xl opacity-80" }
const _hoisted_36 = { class: "flex-1 overflow-hidden" }
const _hoisted_37 = {
  key: 0,
  class: "h-full flex flex-col"
}
const _hoisted_38 = { class: "flex-1 space-y-4" }
const _hoisted_39 = { class: "font-semibold text-5xl flex items-center gap-3 mb-3" }
const _hoisted_40 = { class: "space-y-2 text-5xl" }
const _hoisted_41 = { class: "flex items-center gap-2" }
const _hoisted_42 = { class: "flex items-center justify-between" }
const _hoisted_43 = { class: "flex items-center gap-2" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_46 = {
  key: 0,
  class: "flex-shrink-0 mt-4 flex justify-center"
}
const _hoisted_47 = { class: "flex items-center gap-2" }
const _hoisted_48 = {
  key: 1,
  class: "h-full flex flex-col items-center justify-center opacity-60"
}
const _hoisted_49 = { class: "bg-black/20 backdrop-blur-sm px-8 py-4 text-center border-t border-white/20 fixed bottom-0 left-0 right-0" }
const _hoisted_50 = { class: "text-lg flex items-center justify-center gap-8" }
const _hoisted_51 = { class: "flex items-center gap-2" }
const _hoisted_52 = { class: "flex items-center gap-2 text-green-300" }
const _hoisted_53 = {
  key: 0,
  class: "text-orange-300"
}
const _hoisted_54 = { key: 1 }

import { ref, onMounted, onUnmounted, nextTick, computed } from 'vue'
import axios from 'axios'
import config from '@/config/config'

interface ServizioItem {
  tipoServizio: string
  operatore: string
  oraInizio: string
  oraFine: string
  veicolo?: string
}

interface GiornoData {
  data: string
  nomeGiorno: string
  isToday: boolean
  servizi: ServizioItem[]
}

interface ComuneData {
  comune: string
  giorni: GiornoData[]
}

// Reactive state

export default /*@__PURE__*/_defineComponent({
  __name: 'MonitorPianificazioni',
  setup(__props) {

const loading = ref(false)
const error = ref<string | null>(null)
const monitorData = ref<ComuneData[]>([])
const lastUpdate = ref<Date | null>(null)

// Header state
const showHeader = ref(false)
const headerPinned = ref(false)

// Slideshow state
const currentComuneIndex = ref(0)
const currentWeekIndex = ref(0)
const isPaused = ref(false)
const slideshowTimer = ref<number | null>(null)
const remainingTime = ref(config.SLIDESHOW_DURATION_SECONDS || 10)
const countdownTimer = ref<number | null>(null)

// Pagination state
const SERVIZI_PER_PAGINA = config.SERVIZI_PER_PAGINA || 4
const currentPages = ref<Map<string, number>>(new Map()) // giornoData -> currentPage
const paginationTimers = ref<Map<string, number>>(new Map()) // giornoData -> timer
const isWaitingForPagination = ref(false)
const paginationCompleted = ref<Map<string, boolean>>(new Map()) // giornoData -> completed
const paginationStartTime = ref<Map<string, number>>(new Map()) // Per tracking timing
const totalPaginationCycles = ref<Map<string, number>>(new Map()) // Cicli totali per giorno


// Date controls
const dataInizio = ref('')
const dataFine = ref('')

// API base URL
const API_BASE = config.API_BASE_URL || 'http://localhost:3454'

// Computed properties
const currentComune = computed(() => {
  return monitorData.value[currentComuneIndex.value] || null
})

const progressPercentage = computed(() => {
  if (isWaitingForPagination.value) {
    return 100 // Progress bar piena quando aspetta
  }
  const duration = config.SLIDESHOW_DURATION_SECONDS || 10
  return ((duration - remainingTime.value) / duration) * 100
})

// Week utility functions
function getWeekDates(weekOffset = 0): { start: Date, end: Date } {
  const today = new Date()
  const currentDay = today.getDay()

  let monday = new Date(today)
  if (currentDay === 0) {
    monday.setDate(today.getDate() + 1)
  } else {
    monday.setDate(today.getDate() - (currentDay - 1))
  }

  monday.setDate(monday.getDate() + (weekOffset * 7))
  monday.setHours(0, 0, 0, 0)

  const sunday = new Date(monday)
  sunday.setDate(monday.getDate() + 6)
  sunday.setHours(23, 59, 59, 999)

  return { start: monday, end: sunday }
}

function setWeekDates(weekOffset: number) {
  const { start, end } = getWeekDates(weekOffset)
  dataInizio.value = formatDateForInput(start)
  dataFine.value = formatDateForInput(end)
}

function formatDateForInput(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// Data loading
async function loadData() {
  loading.value = true
  error.value = null

  try {
    const response = await axios.get(`${API_BASE}/api/pianificazioni/monitor`, {
      params: {
        dataInizio: dataInizio.value,
        dataFine: dataFine.value,
        company: '001'
      }
    })

    monitorData.value = response.data
    lastUpdate.value = new Date()
    currentComuneIndex.value = 0

    await nextTick()
    initializePagination()
  } catch (err: unknown) {
    console.error('Error loading data:', err)
    error.value = 'Errore nel caricamento dei dati'
  } finally {
    loading.value = false
  }
}

async function loadDataForWeekCheck(weekIndex: number): Promise<boolean> {
  const { start, end } = getWeekDates(weekIndex)
  const tempDataInizio = formatDateForInput(start)
  const tempDataFine = formatDateForInput(end)

  try {
    const response = await axios.get(`${API_BASE}/api/pianificazioni/monitor`, {
      params: {
        dataInizio: tempDataInizio,
        dataFine: tempDataFine
      }
    })

    if (response.data && response.data.length > 0) {
      monitorData.value = response.data
      lastUpdate.value = new Date()
      currentComuneIndex.value = 0
      await nextTick()
      initializePagination()
      return true
    }
    return false
  } catch (err: unknown) {
    console.error('Error loading week data:', err)
    return false
  }
}

// Pagination functions
function needsPagination(giorno: GiornoData): boolean {
  return giorno.servizi.length > SERVIZI_PER_PAGINA
}

function getTotalPages(giornoData: string): number {
  const giorno = getWeekdaysOnly(currentComune.value?.giorni)?.find(g => g.data === giornoData)
  if (!giorno) return 1
  return Math.ceil(giorno.servizi.length / SERVIZI_PER_PAGINA)
}

function getCurrentPage(giornoData: string): number {
  return currentPages.value.get(giornoData) || 1
}

function hasActivePagination(giornoData: string): boolean {
  return getTotalPages(giornoData) > 1
}

function getVisibleServizi(giorno: GiornoData): ServizioItem[] {
  const currentPage = getCurrentPage(giorno.data)
  const startIndex = (currentPage - 1) * SERVIZI_PER_PAGINA
  const endIndex = startIndex + SERVIZI_PER_PAGINA
  return giorno.servizi.slice(startIndex, endIndex)
}

function initializePagination() {
  stopAllPagination()
  currentPages.value.clear()
  paginationCompleted.value.clear()
  paginationStartTime.value.clear()
  totalPaginationCycles.value.clear()
  isWaitingForPagination.value = false

  if (!currentComune.value) return

  const weekdays = getWeekdaysOnly(currentComune.value.giorni)

  weekdays.forEach(giorno => {
    currentPages.value.set(giorno.data, 1)
    paginationCompleted.value.set(giorno.data, false)

    if (needsPagination(giorno)) {
      const totalPages = getTotalPages(giorno.data)
      totalPaginationCycles.value.set(giorno.data, totalPages)
      paginationStartTime.value.set(giorno.data, Date.now())
      
      startPaginationForGiorno(giorno.data)
    } else {
      paginationCompleted.value.set(giorno.data, true)
    }
  })
}

function startPaginationForGiorno(giornoData: string) {
  const totalPages = getTotalPages(giornoData)
  if (totalPages <= 1) {
    paginationCompleted.value.set(giornoData, true)
    return
  }
  
  let currentPage = 1
  let cyclesCompleted = 0
  const maxCycles = 1 // Un solo ciclo completo

  const timer = setInterval(() => {
    if (isPaused.value) {
      return
    }

    currentPage++
    
    if (currentPage > totalPages) {
      // Completato un ciclo
      cyclesCompleted++
      
      if (cyclesCompleted >= maxCycles) {
        // Paginazione completata
        paginationCompleted.value.set(giornoData, true)
        clearInterval(timer)
        paginationTimers.value.delete(giornoData)
        
        // Mantieni l'ultima pagina visibile per un momento, poi reset
        setTimeout(() => {
          currentPages.value.set(giornoData, 1)
        }, 1000)
        
        // Controlla se tutte le paginazioni sono complete
        checkAllPaginationsCompleted()
        return
      }
      
      // Ricomincia dal primo
      currentPage = 1
    }
    
    currentPages.value.set(giornoData, currentPage)
  }, config.PAGE_DISPLAY_TIME_MS)

  paginationTimers.value.set(giornoData, timer)
}

function checkAllPaginationsCompleted() {
  if (areAllPaginationsCompleted()) {
    isWaitingForPagination.value = false
  }
}

function stopAllPagination() {
  paginationTimers.value.forEach(timer => {
    clearInterval(timer)
  })
  paginationTimers.value.clear()
}

function areAllPaginationsCompleted(): boolean {
  if (!currentComune.value) {
    return true
  }

  const weekdays = getWeekdaysOnly(currentComune.value.giorni)
  const paginationGiorni = weekdays.filter(giorno => needsPagination(giorno))
  
  if (paginationGiorni.length === 0) {
    return true
  }

  const completed = paginationGiorni.every(giorno => {
    const isCompleted = paginationCompleted.value.get(giorno.data) === true
    return isCompleted
  })

  return completed
}

// Slideshow controls
function startSlideshow() {
  stopSlideshow()
  startCountdown()

  slideshowTimer.value = setInterval(async () => {
    if (isPaused.value) return

    // Controlla se sono passati i 10 secondi base
    if (remainingTime.value <= 0) {
      if (areAllPaginationsCompleted()) {
        await nextSlide()
      } else {
        // Inizia ad attendere il completamento delle paginazioni
        if (!isWaitingForPagination.value) {
          isWaitingForPagination.value = true
        }
      }
    }

    // Se siamo in attesa, controlla se sono completate
    if (isWaitingForPagination.value) {
      if (areAllPaginationsCompleted()) {
        isWaitingForPagination.value = false
        await nextSlide()
      }
    }
  }, 1000)
}

function stopSlideshow() {
  if (slideshowTimer.value) {
    clearInterval(slideshowTimer.value)
    slideshowTimer.value = null
  }
  stopCountdown()
}

function startCountdown() {
  const duration = config.SLIDESHOW_DURATION_SECONDS || 10
  remainingTime.value = duration
  countdownTimer.value = setInterval(() => {
    if (!isPaused.value && !isWaitingForPagination.value) {
      remainingTime.value--
      if (remainingTime.value < 0) {
        remainingTime.value = 0
      }
    }
  }, 1000)
}


function stopCountdown() {
  if (countdownTimer.value) {
    clearInterval(countdownTimer.value)
    countdownTimer.value = null
  }
}

async function nextSlide() {
  isWaitingForPagination.value = false

  if (currentComuneIndex.value < monitorData.value.length - 1) {
    currentComuneIndex.value++
  } else {
    // Fine dei comuni, prova settimana successiva
    const nextWeekIndex = currentWeekIndex.value === 0 ? 1 : 0
    setWeekDates(nextWeekIndex)

    const hasData = await loadDataForWeekCheck(nextWeekIndex)

    if (hasData) {
      currentWeekIndex.value = nextWeekIndex
    } else {
      // Torna alla settimana corrente
      setWeekDates(0)
      currentWeekIndex.value = 0
      await loadData()
    }
  }

  remainingTime.value = config.SLIDESHOW_DURATION_SECONDS || 10
  await nextTick()
  initializePagination()
}

function previousComune() {
  isWaitingForPagination.value = false

  if (currentComuneIndex.value > 0) {
    currentComuneIndex.value--
  } else {
    currentComuneIndex.value = monitorData.value.length - 1
  }
  remainingTime.value = config.SLIDESHOW_DURATION_SECONDS || 10
  nextTick(() => initializePagination())
}

function nextComune() {
  nextSlide()
}

function togglePause() {
  isPaused.value = !isPaused.value
}

// Utility functions
function getWeekdaysOnly(giorni: GiornoData[] | undefined): GiornoData[] {
  if (!giorni) return []

  // Filtra solo i giorni feriali (lunedì-sabato)
  return giorni.filter(giorno => {
    const date = new Date(giorno.data)
    const dayOfWeek = date.getDay()
    return dayOfWeek !== 0 // 0 = domenica
  })
}

function getTotalGiorni(comuneData: ComuneData | null): number {
  return getWeekdaysOnly(comuneData?.giorni).length
}

function getTotalServiziComune(comuneData: ComuneData | null): number {
  const weekdays = getWeekdaysOnly(comuneData?.giorni)
  return weekdays.reduce((total, giorno) => total + giorno.servizi.length, 0)
}

function formatDateShort(dateString: string): string {
  const date = new Date(dateString)
  return `${date.getDate()}/${String(date.getMonth() + 1).padStart(2, '0')}`
}

function formatDateTime(date: Date): string {
  return date.toLocaleString('it-IT')
}

function getGiornoClasses(giorno: GiornoData): string {
  const baseClasses = 'border'

  if (giorno.isToday) {
    return `${baseClasses} bg-yellow-500/20 border-yellow-400`
  } else if (giorno.servizi.length > 0) {
    return `${baseClasses} bg-white/10 border-white/20`
  } else {
    return `${baseClasses} bg-gray-600/20 border-gray-500/30`
  }
}

function getServizioClasses(servizio: ServizioItem): string {
  const tipo = servizio.tipoServizio.toLowerCase()

  if (tipo.includes('umido')) return 'bg-amber-900 border-amber-500'
  if (tipo.includes('secco')) return 'bg-gray-600 border-gray-500'
  if (tipo.includes('plastica')) return 'bg-yellow-600 border-yellow-500'
  if (tipo.includes('carta')) return 'bg-blue-600/20 border-blue-500'
  if (tipo.includes('vetro')) return 'bg-green-600/20 border-green-500'
  if (tipo.includes('verde')) return 'bg-emerald-700 border-emerald-500'
  if (tipo.includes('spazzamento')) return 'bg-orange-600 border-orange-500'
  if (tipo.includes('gestione') || tipo.includes('cdr')) return 'bg-purple-600/20 border-purple-500'

  return 'bg-slate-600/20 border-slate-500'
}

function getServizioIcon(tipoServizio: string): string {
  const tipo = tipoServizio.toLowerCase()

  if (tipo.includes('umido')) return 'fas fa-seedling'
  if (tipo.includes('secco')) return 'fas fa-trash-alt'
  if (tipo.includes('plastica')) return 'fas fa-recycle'
  if (tipo.includes('carta')) return 'fas fa-file-alt'
  if (tipo.includes('vetro')) return 'fas fa-wine-bottle'
  if (tipo.includes('verde')) return 'fas fa-leaf'
  if (tipo.includes('spazzamento')) return 'fas fa-broom'
  if (tipo.includes('gestione') || tipo.includes('cdr')) return 'fas fa-cogs'

  return 'fas fa-tools'
}

// Header management
function handleHeaderMouseLeave() {
  if (!headerPinned.value) {
    showHeader.value = false
  }
}

function toggleHeaderPin() {
  headerPinned.value = !headerPinned.value
}

// Lifecycle
onMounted(() => {
  setWeekDates(0)
  loadData().then(() => {
    if (monitorData.value.length > 0) {
      startSlideshow()
    }
  })
})

onUnmounted(() => {
  stopSlideshow()
  stopAllPagination()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "headerControls",
      class: _normalizeClass(["bg-black/20 backdrop-blur-sm px-8 py-6 flex justify-between items-center shadow-xl fixed top-0 left-0 right-0 z-50", {
        'translate-y-0': showHeader.value || headerPinned.value,
        '-translate-y-full': !showHeader.value && !headerPinned.value
      }]),
      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (showHeader.value = true)),
      onMouseleave: handleHeaderMouseLeave
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-4xl font-light" }, "Monitor Pianificazioni", -1)),
        _createElementVNode("button", {
          onClick: toggleHeaderPin,
          class: _normalizeClass(["px-4 py-3 bg-white/10 hover:bg-white/20 rounded-lg transition-colors flex items-center gap-2", { 'bg-yellow-500/30 text-yellow-200': headerPinned.value }])
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(headerPinned.value ? 'fas fa-thumbtack' : 'fas fa-thumbtack'),
            style: _normalizeStyle({ transform: headerPinned.value ? 'rotate(45deg)' : 'rotate(0deg)' })
          }, null, 6),
          _createElementVNode("span", null, _toDisplayString(headerPinned.value ? 'Fissato' : 'Fissa'), 1)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (monitorData.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(currentComuneIndex.value + 1) + "/" + _toDisplayString(monitorData.value.length), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(["h-full transition-all duration-300 ease-linear", isWaitingForPagination.value ? 'bg-orange-400' : 'bg-blue-400']),
                  style: _normalizeStyle({ width: `${progressPercentage.value}%` })
                }, null, 6)
              ]),
              _createElementVNode("span", _hoisted_7, [
                _createTextVNode(_toDisplayString(remainingTime.value) + "s ", 1),
                (isWaitingForPagination.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-calendar-week" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(currentWeekIndex.value === 0 ? 'Settimana corrente' : 'Prossima settimana'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            onClick: previousComune,
            class: "px-4 py-3 bg-blue-500 hover:bg-blue-600 rounded-lg transition-colors"
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
          ])),
          _createElementVNode("button", {
            onClick: togglePause,
            class: _normalizeClass(["px-4 py-3 rounded-lg transition-colors", isPaused.value ? 'bg-green-500 hover:bg-green-600' : 'bg-yellow-500 hover:bg-yellow-600'])
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(isPaused.value ? 'fas fa-play' : 'fas fa-pause')
            }, null, 2)
          ], 2),
          _createElementVNode("button", {
            onClick: nextComune,
            class: "px-4 py-3 bg-blue-500 hover:bg-blue-600 rounded-lg transition-colors"
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
          ]))
        ]),
        _createElementVNode("button", {
          onClick: loadData,
          disabled: loading.value,
          class: "px-6 py-3 bg-green-500 hover:bg-green-600 disabled:opacity-60 rounded-lg transition-colors flex items-center gap-2"
        }, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_13))
            : (_openBlock(), _createElementBlock("i", _hoisted_14)),
          _cache[7] || (_cache[7] = _createTextVNode(" Aggiorna "))
        ], 8, _hoisted_12)
      ])
    ], 34),
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "h-24" }, null, -1)),
    _createElementVNode("div", {
      class: "fixed top-0 left-0 right-0 h-4 z-40",
      onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (showHeader.value = true))
    }, null, 32),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[8] || (_cache[8] = [
          _createElementVNode("div", { class: "w-16 h-16 border-4 border-white/30 border-t-white rounded-full animate-spin" }, null, -1),
          _createElementVNode("span", { class: "text-2xl" }, "Caricamento dati...", -1)
        ])))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-2xl font-medium mb-4" }, "Errore nel caricamento", -1)),
          _createElementVNode("p", _hoisted_17, _toDisplayString(error.value), 1),
          _createElementVNode("button", {
            onClick: loadData,
            class: "px-8 py-4 bg-red-500 hover:bg-red-600 rounded-lg transition-colors text-lg"
          }, " Riprova ")
        ]))
      : _createCommentVNode("", true),
    (!loading.value && !error.value && monitorData.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[10] || (_cache[10] = [
          _createElementVNode("h3", { class: "text-3xl font-medium mb-6" }, "Nessun dato disponibile", -1),
          _createElementVNode("p", { class: "text-xl" }, "Non ci sono pianificazioni per il periodo selezionato.", -1)
        ])))
      : _createCommentVNode("", true),
    (!loading.value && !error.value && monitorData.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("h2", _hoisted_24, [
                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(currentComune.value?.comune), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, [
                      _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-calendar-week" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(getTotalGiorni(currentComune.value)) + " giorni ", 1)
                    ]),
                    _createElementVNode("span", _hoisted_27, [
                      _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fas fa-tasks" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(getTotalServiziComune(currentComune.value)) + " servizi ", 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWeekdaysOnly(currentComune.value?.giorni), (giorno) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: giorno.data,
                      class: "relative"
                    }, [
                      (giorno.isToday)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, " OGGI "))
                        : _createCommentVNode("", true),
                      (hasActivePagination(giorno.data))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-layers animate-pulse" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(getCurrentPage(giorno.data)) + "/" + _toDisplayString(getTotalPages(giorno.data)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWeekdaysOnly(currentComune.value?.giorni), (giorno) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: giorno.data,
                    class: _normalizeClass(["flex flex-col rounded-xl p-6 border transition-colors relative", getGiornoClasses(giorno)])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex-shrink-0 mb-6 pb-4 border-b flex items-center justify-between", giorno.isToday ? 'border-yellow-300/50' : 'border-white/20'])
                    }, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("h3", {
                          class: _normalizeClass(["text-6xl font-medium", giorno.isToday ? 'text-yellow-300' : 'text-blue-300'])
                        }, _toDisplayString(giorno.nomeGiorno.toUpperCase()), 3),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(formatDateShort(giorno.data)), 1)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["text-4xl rounded-full px-3 py-1 flex items-center gap-1 whitespace-nowrap", giorno.servizi.length > 0
                  ? (giorno.isToday ? 'bg-yellow-500/30 text-yellow-100' : 'bg-purple-500/30')
                  : 'bg-gray-500/30 text-gray-300'])
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(giorno.servizi.length > 0 ? 'fas fa-list' : 'fas fa-calendar-times')
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(giorno.servizi.length), 1)
                      ], 2)
                    ], 2),
                    _createElementVNode("div", _hoisted_36, [
                      (giorno.servizi.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getVisibleServizi(giorno), (servizio, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: _normalizeClass(["rounded-lg p-4 border-l-4 transition-all duration-200", getServizioClasses(servizio)])
                                }, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(getServizioIcon(servizio.tipoServizio))
                                    }, null, 2),
                                    _createTextVNode(" " + _toDisplayString(servizio.tipoServizio), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("div", _hoisted_41, [
                                      _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-user" }, null, -1)),
                                      _createElementVNode("span", null, _toDisplayString(servizio.operatore), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_42, [
                                      _createElementVNode("div", _hoisted_43, [
                                        _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-clock" }, null, -1)),
                                        _createElementVNode("span", null, _toDisplayString(servizio.oraInizio), 1),
                                        (servizio.oraFine)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_44, " - " + _toDisplayString(servizio.oraFine), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (servizio.veicolo)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                            _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-truck" }, null, -1)),
                                            _createElementVNode("span", null, _toDisplayString(servizio.veicolo), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ], 2))
                              }), 128))
                            ]),
                            (needsPagination(giorno))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTotalPages(giorno.data), (pageNum) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: pageNum,
                                        class: _normalizeClass(["w-2 h-2 rounded-full transition-colors", pageNum === getCurrentPage(giorno.data) ? 'bg-blue-400' : 'bg-white/30'])
                                      }, null, 2))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_48, _cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "fas fa-calendar-times text-4xl mb-4" }, null, -1),
                            _createElementVNode("span", { class: "text-lg" }, "Nessun servizio programmato", -1)
                          ])))
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("span", _hoisted_51, [
          _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fas fa-info-circle" }, null, -1)),
          _createTextVNode(" Ultimo aggiornamento: " + _toDisplayString(lastUpdate.value ? formatDateTime(lastUpdate.value) : 'Mai'), 1)
        ]),
        _createElementVNode("span", _hoisted_52, [
          _cache[20] || (_cache[20] = _createElementVNode("i", { class: "fas fa-play animate-pulse" }, null, -1)),
          _cache[21] || (_cache[21] = _createTextVNode(" Slideshow attivo ")),
          (isWaitingForPagination.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_53, "(attendendo pagination)"))
            : (_openBlock(), _createElementBlock("span", _hoisted_54, "(" + _toDisplayString(_unref(config).SLIDESHOW_DURATION_SECONDS || 10) + "s per comune)", 1))
        ]),
        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "flex items-center gap-2 text-purple-300" }, [
          _createElementVNode("i", { class: "fas fa-calendar-week" }),
          _createTextVNode(" Ciclo settimane automatico ")
        ], -1))
      ])
    ])
  ]))
}
}

})